import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';

@Component({
    selector: 'block-dialog',
    templateUrl: 'block.dialog.html',
    styleUrls: ['./block.dialog.css']
})
export class BlockDialog {
    step = 0

    constructor(public translate: TranslateService,
        private userService: UserService,
        private router: Router,
        private dialogRef: MatDialogRef<BlockDialog>) { }

    async block() {
        this.step++;
        await this.userService.blockUser({})
        setTimeout(() => {
            this.dialogRef.close()
            this.logOut()
        }, 4000)
    }

    logOut(){
        localStorage.clear();
        this.router.navigate(['/logon']);
    }

}
